import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api";

export default function LoadEdit() {
  const { id } = useParams();
  const nav = useNavigate();

  const [form, setForm] = useState({
    cases: 0,
    sorts: 0,
    weight: 0,
  });

  const [assignments, setAssignments] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [locked, setLocked] = useState(false);

  useEffect(() => { loadData(); }, [id]);

  const loadData = async () => {
    try {
      const res = await api.get(`/loads/${id}`);

      setForm({
        cases: res.data.cases || 0,
        sorts: res.data.sorts || 0,
        weight: res.data.weight || 0,
      });

      setAssignments(res.data.assignments || []);

      const allClockedOut =
        res.data.assignments?.length > 0 &&
        res.data.assignments.every((a) => a.clock_out);

      setLocked(allClockedOut);

      const empRes = await api.get("/employees-list");
      const assignRes = await api.get("/assignments");

      const busyIds = assignRes.data
        .filter((a) => !a.clock_out)
        .map((a) => a.employee_id);

      setEmployees(empRes.data.filter(e => !busyIds.includes(e.id)));

    } catch {
      alert("Failed to load");
    }
  };

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async () => {
    if (locked) return alert("Load locked");

    await api.put(`/loads/${id}`, form);
    alert("Updated");
    nav("/loads");
  };

  const addEmployee = async () => {
    if (!selectedEmployee) return alert("Select employee");

    await api.post(`/loads/${id}/add-employee`, {
      employee_id: selectedEmployee,
    });

    setSelectedEmployee(null);
    loadData();
  };

  const removeEmployee = async (aid, clockIn) => {
    if (clockIn) return alert("Already started");

    await api.delete(`/loads/${id}/remove-employee/${aid}`);
    loadData();
  };

  return (
    <div className="container-fluid mt-3 px-2">

      <h4>Edit Load</h4>

      {locked && (
        <div className="alert alert-warning">
          ⚠ Load locked (completed)
        </div>
      )}

      {/* INPUTS */}
      <div className="card p-2 mb-3">
        <div className="row g-2">
          <div className="col-4">
            <label>Cases</label>
            <input type="number" name="cases" className="form-control"
              value={form.cases} onChange={handleChange} disabled={locked}/>
          </div>
          <div className="col-4">
            <label>Sorts</label>
            <input type="number" name="sorts" className="form-control"
              value={form.sorts} onChange={handleChange} disabled={locked}/>
          </div>
          <div className="col-4">
            <label>Weight</label>
            <input type="number" name="weight" className="form-control"
              value={form.weight} onChange={handleChange} disabled={locked}/>
          </div>
        </div>
      </div>

      {/* ================= DESKTOP TABLE ================= */}
      <div className="card mb-3 d-none d-md-block">
        <div className="card-body">
          <h6>Assigned Employees</h6>

          <table className="table table-bordered table-sm">
            <thead>
              <tr>
                <th>Employee</th>
                <th>Status</th>
                <th>Clock In</th>
                <th>Clock Out</th>
                {!locked && <th>Action</th>}
              </tr>
            </thead>

            <tbody>
              {assignments.map(a => (
                <tr key={a.id}>
                  <td>{a.employee?.user?.name}</td>
                  <td>
                    {a.clock_out ? "Completed" :
                     a.clock_in ? "Working" : "Pending"}
                  </td>
                  <td>{a.clock_in || "-"}</td>
                  <td>{a.clock_out || "-"}</td>

                  {!locked && (
                    <td>
                      {!a.clock_in && (
                        <button className="btn btn-sm btn-danger"
                          onClick={()=>removeEmployee(a.id, a.clock_in)}>
                          Remove
                        </button>
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ================= MOBILE CARDS ================= */}
      <div className="d-md-none">

        <div className="card p-2 mb-2">
          <h6>👷 Employees</h6>

          {assignments.map(a => (
            <div key={a.id} className="border p-2 mb-1 rounded">

              <div className="d-flex justify-content-between">
                <strong>{a.employee?.user?.name}</strong>

                {!locked && !a.clock_in && (
                  <button className="btn btn-sm btn-danger"
                    onClick={()=>removeEmployee(a.id, a.clock_in)}>
                    Remove
                  </button>
                )}
              </div>

              <div className="small">
                {a.clock_out ? "Completed" :
                 a.clock_in ? "Working" : "Pending"}
              </div>

            </div>
          ))}
        </div>

      </div>

      {/* ================= ADD EMPLOYEE ================= */}
      {!locked && (
        <div className="card p-2 mb-3">
          <h6>Add Employee</h6>

          <select
            className="form-control mb-2"
            value={selectedEmployee || ""}
            onChange={(e)=>setSelectedEmployee(e.target.value)}
          >
            <option value="">Select Employee</option>
            {employees.map(e => (
              <option key={e.id} value={e.id}>
                {e.user?.name}
              </option>
            ))}
          </select>

          <button className="btn btn-success d-md-inline w-100 w-md-auto"
            onClick={addEmployee}>
            Add Employee
          </button>
        </div>
      )}

      {/* ================= ACTION BUTTONS ================= */}

      {/* DESKTOP */}
      {!locked && (
        <div className="d-none d-md-block mb-4">
          <button className="btn btn-primary" onClick={submit}>
            Save Changes
          </button>
        </div>
      )}

      {/* MOBILE STICKY */}
      {!locked && (
        <div className="d-md-none fixed-bottom bg-white p-2 border-top shadow">
          <button className="btn btn-primary w-100" onClick={submit}>
            Save Changes
          </button>
        </div>
      )}

      {/* spacing for mobile */}
      <div className="d-md-none" style={{ height: "70px" }}></div>

    </div>
  );
}